import {
    ChangeDetectionStrategy,
    Component,
    Input,
    OnChanges,
    OnInit,
    SimpleChanges
} from "@angular/core";
import { MathUtils as utils } from "~app/common/utils/math-utils";
import { IArbetsorderDetail } from "~app/features/planera/model/IArbetsorderDetail";
import { IProduktvalRow } from "~app/features/planera/produktval/produktval.models";
import { ArbetsorderUtbyteBehaviour } from "../../behaviours/ArbetsorderUtbyteBehaviour";
import { ArbetsorderProduktvalSummaryTexts } from "./arbetsorder-produktval-summary.texts";

@Component({
    selector: "rask-arbetsorder-produktval-summary",
    templateUrl: "./arbetsorder-produktval-summary.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ["./arbetsorder-produktval-summary.component.scss"]
})
export class ArbetsorderProduktvalSummaryComponent implements OnInit, OnChanges {
    @Input() arbetsorder: IArbetsorderDetail;
    @Input() handelssortimentsgruppProduktvalsrader: { [key: string]: IProduktvalRow[] };

    texts = ArbetsorderProduktvalSummaryTexts.texts;
    totalsumma: number;
    timmerandel: number;
    simuleratUtbyteGrot: number;

    private readonly sagTimmer = "Sågtimmer";

    get totalsummaAsText(): string {
        return this.totalsumma === undefined ? "-" : `${this.totalsumma}`;
    }

    get timmerandelAsText(): string {
        return this.timmerandel === undefined ? "-" : `${this.timmerandel} %`;
    }

    get simuleratUtbyteGrotAsText(): string {
        return this.simuleratUtbyteGrot === undefined ? "-" : `${this.simuleratUtbyteGrot}`;
    }

    ngOnInit() {
        this.arbetsorder.commandManager.onCommandReceived(() => {
            this.summarize();
        });

        this.summarize();
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.summarize();
    }

    private summarize(): void {
        let sum: number | undefined;
        let sumTimmer: number | undefined;

        for (const key in this.handelssortimentsgruppProduktvalsrader) {
            if (Object.hasOwn(this.handelssortimentsgruppProduktvalsrader, key)) {
                const rows = this.handelssortimentsgruppProduktvalsrader[key];

                if (!this.someProduktvalRowsHasKvantitet(rows)) {
                    continue;
                }

                sum = sum ?? 0;
                sumTimmer = sumTimmer ?? 0;

                sum = this.getSumKvantitet(rows, sum);
                sumTimmer = this.getSumOfTimmer(rows, sumTimmer);
            }
        }

        this.totalsumma = sum;

        this.setTimmerAndel(sumTimmer);
        const arbetsorderUtbyteBehaviour = new ArbetsorderUtbyteBehaviour(this.arbetsorder);
        this.simuleratUtbyteGrot = arbetsorderUtbyteBehaviour.simuleratUtbyteGrotV2;
    }

    private someProduktvalRowsHasKvantitet(rows: IProduktvalRow[]): boolean {
        return rows.some(x => x.kvantitet !== undefined || x.simuleradKvantitet !== undefined);
    }

    private getSumKvantitet(rows: IProduktvalRow[], sum: number): number {
        rows.forEach(element => {
            sum += element.kvantitet ?? element.simuleradKvantitet;
        });

        return sum;
    }

    private getSumOfTimmer(rows: IProduktvalRow[], sumTimmer: number): number {
        sumTimmer += utils.sum(rows
            .filter(x => x.handelssortimentKategori === this.sagTimmer)
            .map(r => r.kvantitet ?? r.simuleradKvantitet)
        );

        return sumTimmer;
    }

    private setTimmerAndel(sumTimmer?: number): void {
        if (this.totalsumma && sumTimmer) {
            this.timmerandel = Math.round((sumTimmer / this.totalsumma) * 100);
        }
    }
}
